import { c as _c } from "react/compiler-runtime";
import Tooltip from '@/components/modules/Tooltip';
import RatingCount from '@/components/modules/rating/RatingCount';
import RatingNumber from '@/components/modules/rating/RatingNumber';
import RatingsByCriteria from '@/components/modules/rating/RatingsByCriteria';
import StarRating from '@/components/modules/rating/StarRating';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
const TypeRating = (t0) => {
    const $ = _c(20);
    const { count, criteria } = t0;
    const translate = useTranslate();
    const t1 = `review.rating_type.${criteria.type}`;
    let t2;
    if ($[0] !== t1 || $[1] !== translate) {
        t2 = translate(t1);
        $[0] = t1;
        $[1] = translate;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    const typeLabel = t2;
    let t3;
    if ($[3] !== criteria) {
        t3 = <RatingsByCriteria {...criteria}/>;
        $[3] = criteria;
        $[4] = t3;
    }
    else {
        t3 = $[4];
    }
    let t4;
    if ($[5] !== typeLabel) {
        t4 = <th scope="row" className="mr-2 text-xs xxs:text-sm font-semibold text-gray-400 text-right">
      {typeLabel}
    </th>;
        $[5] = typeLabel;
        $[6] = t4;
    }
    else {
        t4 = $[6];
    }
    let t5;
    let t6;
    if ($[7] !== criteria.average) {
        t5 = <td>
      <StarRating className="mx-3 xs:mx-4" rating={criteria.average}/>
    </td>;
        t6 = <td>
      <RatingNumber rating={criteria.average} className="mr-2"/>
    </td>;
        $[7] = criteria.average;
        $[8] = t5;
        $[9] = t6;
    }
    else {
        t5 = $[8];
        t6 = $[9];
    }
    let t7;
    if ($[10] !== count) {
        t7 = <td>
      <RatingCount count={count} className="text-xs xxs:text-sm"/>
    </td>;
        $[10] = count;
        $[11] = t7;
    }
    else {
        t7 = $[11];
    }
    let t8;
    if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
        t8 = <tr>{t4}{t5}{t6}{t7}
    </tr>;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
    }
    else {
        t8 = $[16];
    }
    let t9;
    if ($[17] !== t3 || $[18] !== t8) {
        t9 = <Tooltip content={t3} siblingTag="tr">{t8}
    </Tooltip>;
        $[17] = t3;
        $[18] = t8;
        $[19] = t9;
    }
    else {
        t9 = $[19];
    }
    return t9;
};
export default TypeRating;
